import { useNavigate } from 'react-router';
import '../styles/EntryHub.css';

// Unified entry hub: ONE front door that routes each role to its existing,
// unchanged sign-in flow. Shown at "/" for an unauthenticated visitor (an
// authenticated office user is auto-routed to their home by RootRedirect).
const ROLES = [
  {
    key: 'installer', to: '/installer', title: 'نیروی اجرایی', sub: 'ورود/ثبت‌نام با موبایل',
    desc: 'انجام و ثبت کارهای نصب، بازرسی هوش مصنوعی، و دریافت کارهای ارجاع‌شده.',
    icon: 'M9 11l3 3L22 4 M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11',
  },
  {
    key: 'contractor', to: '/contractor', title: 'شرکت پیمانکار', sub: 'ورود/ثبت‌نام با موبایل',
    desc: 'مدیریت نیروهای اجرایی زیرمجموعه، مشاهدهٔ کارها و امتیاز کیفیت شرکت.',
    icon: 'M3 21h18 M5 21V7l8-4v18 M19 21V11l-6-3 M9 9v.01 M9 12v.01 M9 15v.01',
  },
  {
    key: 'staff', to: '/login', title: 'اپراتور / مدیر / ناظر', sub: 'ورود با ایمیل',
    desc: 'طراحی شبکه، مدیریت سامانه، و بازبینی بازرسی‌ها (کارکنان دفتری).',
    icon: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M9 7a4 4 0 1 0 0 .01 M22 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75',
  },
  {
    key: 'customer', to: '/customer-register', title: 'مشتری', sub: 'ورود/ثبت‌نام با موبایل',
    desc: 'درخواست فیبر نوری، پیگیری وضعیت پوشش، و گفتگو با مشاور هوشمند.',
    icon: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  },
];

export default function EntryHub() {
  const nav = useNavigate();
  return (
    <div className="hub" dir="rtl">
      <div className="hub-shell">
        <header className="hub-head">
          <h1 className="hub-title">سامانهٔ FTTX</h1>
          <p className="hub-sub">برای ورود، نقش خود را انتخاب کنید.</p>
        </header>
        <div className="hub-grid">
          {ROLES.map((r) => (
            <button key={r.key} type="button" className="hub-card" onClick={() => nav(r.to)}>
              <span className="hub-card-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d={r.icon} />
                </svg>
              </span>
              <span className="hub-card-body">
                <span className="hub-card-title">{r.title}</span>
                <span className="hub-card-tag">{r.sub}</span>
                <span className="hub-card-desc">{r.desc}</span>
              </span>
              <span className="hub-card-arrow" aria-hidden="true">‹</span>
            </button>
          ))}
        </div>
        <p className="hub-foot">شبکهٔ فیبر نوری منزل تا منزل</p>
      </div>
    </div>
  );
}
